export default __webpack_public_path__ + "static/media/freeStorage.b0acffe3.svg";